import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';

import { switchAccountForWithholding } from 'actions';

import LoadingWrapper from 'components/Common/LoadingWrapper';
import WithholdingTable from 'components/WithholdingTable';
import ModalWrapper from '../ModalWrapper';

class WithholdingRatesModal extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    isShown: PropTypes.bool.isRequired,
    isGettingAccountWithholding: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
    accountWithholding: PropTypes.arrayOf(PropTypes.shape({}))
  };

  static defaultProps = {
    isGettingAccountWithholding: false,
    accountWithholding: null
  };

  constructor(props) {
    super(props);
    this.state = {
      accountList: null,
      selectedAccount: null
    };
  }

  componentDidUpdate() {
    const { accountList } = this.state;
    const { accountWithholding } = this.props;

    if (accountList == null && accountWithholding !== null) {
      this.setAccountList();
    }
  }

  onAccountValueChanged(e) {
    const { dispatch } = this.props;
    this.setState({ selectedAccount: e.target.value });
    dispatch(switchAccountForWithholding(e.target.value));
  }

  setAccountList() {
    const { accountList, selectedAccount } = this.state;
    const { accountWithholding } = this.props;

    if (accountList == null) {
      this.setState({ accountList: accountWithholding });
    }

    if (selectedAccount !== null) {
      this.setState({ selectedAccount: null });
    }
  }

  closeModal() {
    const { onClose } = this.props;
    this.setState({ accountList: null });
    this.setState({ selectedAccount: null });
    onClose();
  }

  render() {
    const {
      isShown,
      isGettingAccountWithholding,
      accountWithholding
    } = this.props;
    const { accountList, selectedAccount } = this.state;
    const withholdingContainer = accountWithholding && accountWithholding.length > 0 && accountWithholding[0];

    function dateFormatter(value, format) {
      return moment(value).format(format);
    }

    function getDateCalculated(withholding) {
      if (withholding && withholding[0] !== null && withholding[0].rates) {
        if (withholding[0].dateCalculated !== null) {
          return `${ dateFormatter(withholding[0].dateCalculated, 'MMM DD, YYYY') }`;
        }
      }
      return 'N/A';
    }

    return (
      <ModalWrapper
        isOpen={ isShown }
        title="Withholding Rates"
        btnCancelTitle="Close"
        onCancel={ e => this.closeModal() }
        showFooter={ false }
        modalSize="modal-lg whd-rates-modal"
      >
        { isGettingAccountWithholding && <LoadingWrapper loaded={ !isGettingAccountWithholding } /> }
        { !isGettingAccountWithholding && accountWithholding && <div>

          <div className="form-group">
            <div className="col-2">
              <label className="form-label">Selected Account:</label>
            </div>
            <div className="col-10">
              <select
                id="account-list"
                name="accountList"
                className="form-select"
                required
                value={ selectedAccount !== null ? selectedAccount : '' }
                onChange={ e => this.onAccountValueChanged(e) }
              >
                { accountList != null && accountList.map((option, i) => (
                  <option key={ option.accountId } value={ option.accountId }>
                    {option.accountName} -- {option.accountNumber}
                  </option>
                )) }
              </select>
            </div>
          </div>
          <div className="form-group">
            <div className="col-2">
              <label className="form-label">Date Calculated:</label>
            </div>
            <div className="col-10">
              <span>{ getDateCalculated(accountWithholding) }</span>
            </div>
          </div>
          <WithholdingTable accountWithholding={ withholdingContainer } />
          </div> }
      </ModalWrapper>
    );
  }
}

function mapStateToProps(state) {
  const { forms: {
    isGettingAccountWithholding,
    accountWithholding
  } } = state;

  return {
    isGettingAccountWithholding,
    accountWithholding
  };
}

const mapDispatchToProps = dispatch => ({ dispatch });

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WithholdingRatesModal);
